import { type LinearConfigurationUpdate } from "../../Linear/models";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { type CsticUpdate } from "../../Linear/api/sendLinearConfiguratorUpdate";
import { prepareCommonRailData, sendRail } from "./sendRailCommon";
import { prepareApiDataForUpdate } from "../../common/commonConfiguratorApi";

export function sendRailUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[]
): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonRailData(linearState);

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  return sendRail({
    ...data,
    ...updateData,
  });
}
